@import '../../../../../../constants/spacing.module.less';

.radio-options-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(3, auto);
  grid-auto-flow: column;
  gap: @space-8 @space-24;
}

.radio-button {
  padding: @space-0;
  height: 24px;
  display: flex;
  align-items: center;
}
